/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable array-callback-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import { Button, Container, CssBaseline, Grid } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import moment from 'moment';
import copy from 'copy-to-clipboard';
import useStyles from '../../../../assets/styles/pages/Request';
import Header from '../../../../components/Header';
import FooterMenuMain from '../../../../components/FooterMenuMain';

import imgIconChat from '../../../../assets/images/chat.png';

import { ReactComponent as IconWallet } from '../../../../assets/images/svg/shops/request/icon_carteira.svg';
import { ReactComponent as IconChecked } from '../../../../assets/images/svg/shops/request/icon_check_ok.svg';

import { useLoadingContext } from '../../../../providers/use-loading';
import { useSignInContext } from '../../../../providers/use-signin';
import { ItypeReturnApi } from '../../../../helpers/utils/TypeReturnApi';
import { api } from '../../../../services';
import { FormatPrice } from '../../../../helpers/utils/Formating';
import ColorSituationRequest from '../../../../helpers/utils/ColorStatusRequest';
import CountDownTimer from '../../../../components/CountDownTimer';
import {
  getStorege,
  removeStorege,
  saveStorege,
} from '../../../../helpers/db_storage';
import ModalListCenter from '../../../../components/Modal/ListCenter';
import ModalConfirmFooter from '../../../../components/Modal/ConfirmFooter';

const OrderDetail: React.FC = () => {
  const classeStyle = useStyles();
  const { createloading } = useLoadingContext();
  const { data, signingOut } = useSignInContext();
  const { id_request, id_shop }: any = useParams();
  const navigate = useNavigate();

  const [copyTextKeyPix, setCopyTextKeyPix] = useState('');
  const [textModal, setTextModal] = useState<any>({
    title: '',
    description: '',
    icon: '',
  });
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [openModalNotice, setOpenModalNotice] = useState(false);
  const [msgnModalNotice, setMsgModalNotice] = useState({
    title: 'Atenção',
    messagem: '',
  });
  const [request, setRequet] = useState<any>();
  const [historyRquest, seThistoryRquest] = useState<any>();
  const [formPayment, setFormPayment] = useState<any>();
  const [openModalListPaymentFormat, setOpenModalListPaymentFormat] =
    useState(false);
  const [selectedFormPayment, setSelectedFormPayment] = useState<any>(0);

  const dataUserStorageOrder = getStorege(
    '@mais/delivery/authorization/orders',
  );

  const handleToPageExterno = (url: string): any => {
    window.location.replace(url);
  };

  const handleToPage = (url: string): any => {
    return navigate(url);
  };

  const handleFormPayment = async () => {
    try {
      createloading(true);
      const [resultTypePayment]: any = await Promise.all([
        api.apiMaisdelivery.shop.getParamsShop({
          nr_operacao: 31,
          idRestaurante: window.atob(id_shop),
          idPagamentoForma: 0,
          dsFiltroPagamentoCupom: 0,
        }),
      ]);

      setFormPayment(resultTypePayment.data);
      setOpenModalListPaymentFormat(true);
      createloading(false);
    } catch (error) {
      createloading(false);
      toast.error('Formas de pagamento não encontradas');
    }
  };

  const getRequest = async () => {
    createloading(true);
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.getRequest({
        nr_operacao: 25,
        idUsuario: data.user?.idUsuario || dataUserStorageOrder?.idUsuario,
        idRestaurante: window.atob(id_shop),
        idPedido: window.atob(id_request),
        TipoRetorno: 2,
      });

      setRequet(result.data);
      seThistoryRquest(result.data.detalhes?.dsHistorico?.split('.'));
      setCopyTextKeyPix(result.data.detalhes?.dsQRCodePixLinha);
    } catch (error: any) {
      if (error.response.status === 401) {
        signingOut({
          http_status: 401,
          location: 'listAddress',
          id_shop: '',
        });
        toast.info('Sua sessão expirou, por favor faça login novamente');
      } else {
        toast.error('Ocorreu um erro ao buscar o pedido');
      }
    } finally {
      createloading(false);
    }
  };

  const checkStatusRequest = async () => {
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.getRequest({
        nr_operacao: 37,
        idPedido: window.atob(id_request),
      });
      if (result?.data?.idSituacao != -1) {
        request.detalhes.idSituacao = result?.data?.idSituacao;
        request.detalhes.dsSituacao = result?.data?.dsSituacao;
        request.detalhes.dsQRCodePixBase64 = '';
        request.detalhes.dsQRCodePixLinha = '';
        window.location.reload();
        setRequet(request);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  const copyToClipboard = () => {
    copy(copyTextKeyPix);
    setTextModal({
      title: 'Atenção',
      description:
        'O código PIX foi copiado, agora é só colar no aplicativo do seu banco e fazer o pagamento! (PAGAR NA OPÇÃO PIX COPIA E COLAR DO SEU BANCO)',
    });
    setOpenErrorModal(true);
  };

  const copyKeyPixOff = (key: string) => {
    copy(key);
    setTextModal({
      title: 'Atenção',
      description:
        'A chave PIX foi copiado, agora é só colar no aplicativo do seu banco e fazer o pagamento!',
    });
    setOpenErrorModal(true);
  };

  const handleToChat = (orderData: any) => {
    saveStorege('@chat/order', { ...orderData, lat: null, lng: null });
    handleToPage('/dashboard/user/request/chat');
  };

  const handleChangeFormPayment = async (
    idPedido: any,
    idPagamento: any,
    flgRemoveCupom = 0,
  ): Promise<Promise<void>> => {
    try {
      createloading(true);
      setOpenModalListPaymentFormat(false);

      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.getRequest({
        nr_operacao: 77,
        idUsuario: data.user?.idUsuario || dataUserStorageOrder?.idUsuario,
        idPedido,
        idPagamento,
        flgRemoveCupom,
      });
      createloading(false);
      if (result.data.retorno == 'NOK' && result.data.confirma == 1) {
        setMsgModalNotice({
          title: 'Confirmação',
          messagem: result.data.mensagem,
        });
        setSelectedFormPayment(idPagamento);
        setOpenModalNotice(true);
        return;
      }
      if (result.data.retorno == 'OK') {
        getRequest();
        setTextModal({
          title: 'Informação',
          description: result.data.mensagem,
          icon: <IconChecked height={35} width={35} />,
        });
        setOpenErrorModal(true);
      } else {
        setTextModal({
          title: 'Atenção',
          description: result.data.mensagem,
          icon: '',
        });
        setOpenErrorModal(true);
      }
    } catch (error) {
      createloading(false);
      toast.error('Não foi possível alterar forma de pagamento.');
    }
  };

  useEffect(() => {
    if (data.user?.idUsuario || dataUserStorageOrder?.idUsuario) {
      getRequest();
    }
  }, [data.user, dataUserStorageOrder?.idUsuario]);

  useEffect(() => {
    if (request?.detalhes?.dsQRCodePixBase64) {
      const getMsgPaymentLocalStorege = async () => {
        const result = getStorege('@mais/delivery/shop/datapply');
        if (result?.mensagem) {
          setTextModal({
            title: 'Atenção',
            description: result.mensagem,
          });
          setOpenErrorModal(true);
          removeStorege('@mais/delivery/shop/datapply');

          await new Promise((resolve) => {
            setTimeout(resolve, 5000);
          });
          setOpenErrorModal(false);
        }
      };
      getMsgPaymentLocalStorege();
    }
  }, [request?.detalhes?.dsQRCodePixBase64]);

  useEffect(() => {
    const closeModal = async () => {
      if (openErrorModal) {
        await new Promise((resolve) => {
          setTimeout(resolve, 7000);
        });
        setOpenErrorModal(false);
      }
    };
    closeModal();
  }, [openErrorModal]);

  const date = moment(
    request?.detalhes?.dtVencPagamento,
    'DD/MM/YYYY HH:mm:ss Z',
  ).format();

  useEffect(() => {
    setInterval(() => {
      if (request?.detalhes?.idSituacao == -1) {
        checkStatusRequest();
      }
    }, 60000);
  }, [request]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      {request?.detalhes?.idPedido && historyRquest && (
        <>
          <Header
            children={
              request.detalhes.idSituacao == 6 ||
              request.detalhes.idSituacao == 9 ||
              request.detalhes.idSituacao == -1 ||
              request.detalhes.idSituacao == -2
                ? 'UserDetailRequest'
                : {
                    type: 'UserRequestProgress',
                    phone: request.detalhes.nrTelefoneEst,
                  }
            }
          />
          <CssBaseline />
          <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            marginBottom="100px"
          >
            {request?.detalhes?.idPagamentoForma == 3 &&
              request?.detalhes?.idSituacao == -1 && (
                <Grid
                  container
                  item
                  justifyContent="center"
                  alignItems="center"
                >
                  <img
                    className={classeStyle.imgBase64Pix}
                    src={`data:image/png;base64, ${request.detalhes.dsQRCodePixBase64}`}
                    alt="qrcode"
                  />
                  <Grid item xs={12} container justifyContent="center">
                    <h5 className={classeStyle.titlePix}>
                      Pedido aguardando pagamento PIX
                    </h5>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    container
                    justifyContent="center"
                    textAlign="center"
                  >
                    <p className={classeStyle.descriptionPix}>
                      Copie o código abaixo para pagar via Pix em qualquer
                      aplicativo habilitado:
                    </p>
                  </Grid>

                  <Grid item xs={10} onClick={copyToClipboard}>
                    <input
                      type="text"
                      style={{ width: '100%' }}
                      defaultValue={request?.detalhes?.dsQRCodePixLinha}
                      placeholder="Codigo Pix"
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    container
                    justifyContent="center"
                    textAlign="center"
                  >
                    <p className={classeStyle.textTempLimitPix}>
                      Tempo restante para pagamento:{' '}
                      <CountDownTimer
                        children={moment(new Date(date)).format('X')}
                      />
                    </p>
                  </Grid>

                  <Button
                    className={classeStyle.btnSubmit}
                    style={{ display: 'block', width: '85%' }}
                    type="submit"
                    variant="contained"
                    onClick={copyToClipboard}
                  >
                    <p className={classeStyle.textBtnCopyPix}>
                      Copiar código PIX
                    </p>
                    <p
                      className={classeStyle.textBtnCopyPix}
                      style={{ fontSize: 10 }}
                    >
                      (Pagar na opção pix copia e colar do seu banco)
                    </p>
                  </Button>
                </Grid>
              )}

            {request?.detalhes?.idPagamentoForma == 1 &&
              request?.detalhes?.idSituacao == -1 && (
                <Button
                  className={classeStyle.btnSubmit}
                  style={{ display: 'block', width: '85%' }}
                  variant="contained"
                  onClick={() =>
                    handleToPageExterno(
                      `/painel/datapaymentcardbrick.php?id=${id_request}&origin=${window.btoa(
                        'pwa',
                      )}`,
                    )
                  }
                >
                  <p className={classeStyle.textBtnCopyPix}>
                    Pagar com cartão de credito
                  </p>
                </Button>
              )}

            {request?.detalhes?.flgPix == 1 &&
              (request?.detalhes?.dsImagemCompPix == '' ||
                request?.detalhes?.dsImagemCompPix == null) &&
              ![6, 9].find(
                (situation) =>
                  Number(situation) == Number(request?.detalhes?.idSituacao),
              ) && (
                <Grid
                  container
                  item
                  justifyContent="center"
                  alignItems="center"
                  marginBottom="25px"
                >
                  <Grid item xs={12} container justifyContent="center">
                    <h5 className={classeStyle.titlePix}>
                      Faça o envio do comprovante para iniciar seu pedido
                    </h5>
                  </Grid>

                  <Button
                    className={classeStyle.btnSubmit}
                    style={{ display: 'block', width: '85%' }}
                    type="submit"
                    variant="contained"
                    onClick={() =>
                      handleToPage(
                        `/dashboard/user/request/detail/upload/file/pix/${id_request}/${id_shop}`,
                      )
                    }
                  >
                    <p className={classeStyle.textBtnCopyPix}>
                      Clique aqui para enviar comprovante
                    </p>
                    <p
                      className={classeStyle.textBtnCopyPix}
                      style={{ fontSize: 10 }}
                    >
                      (Para iniciar seu pedido é necessário enviar comprovante)
                    </p>
                  </Button>
                  <Grid
                    item
                    xs={12}
                    container
                    justifyContent="center"
                    textAlign="center"
                  >
                    <p className={classeStyle.descriptionPix}>
                      Copie a chave pix abaixo para pagar via Pix em qualquer
                      aplicativo habilitado:
                    </p>
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    marginTop="10px"
                    container
                    alignItems="center"
                    onClick={() => copyKeyPixOff(request?.detalhes?.dsChavePix)}
                  >
                    <Grid item xs={3}>
                      <b>{request?.detalhes?.tpChavePix}</b>
                    </Grid>
                    <Grid item xs={9}>
                      <input
                        type="text"
                        style={{ width: '100%' }}
                        readOnly
                        defaultValue={
                          request?.detalhes?.flgPix == 1
                            ? request?.detalhes?.dsChavePix
                            : request?.detalhes?.dsPagamento
                        }
                        placeholder="Codigo Pix"
                      />
                    </Grid>
                  </Grid>

                  <Button
                    style={{ marginTop: 10, display: 'block', width: '85%' }}
                    onClick={() => copyKeyPixOff(request?.detalhes?.dsChavePix)}
                  >
                    <p className={classeStyle.textBtnCopyPix}>
                      Copiar CHAVE PIX
                    </p>
                  </Button>
                </Grid>
              )}

            {request?.detalhes?.flgPix == 1 &&
              request?.detalhes?.dsImagemCompPix != '' &&
              request?.detalhes?.dsImagemCompPix != null && (
                <Grid
                  container
                  item
                  justifyContent="center"
                  alignItems="center"
                  marginBottom="25px"
                >
                  <Grid item xs={12} container justifyContent="center">
                    <h5
                      className={classeStyle.titlePix}
                      style={{ background: '#fbd4d4', padding: 5 }}
                    >
                      Comprovante enviado com sucesso!
                    </h5>
                  </Grid>
                </Grid>
              )}

            {(request?.detalhes?.idPagamentoForma == 3 ||
              request?.detalhes?.idPagamentoForma == 1) &&
              request?.detalhes?.idSituacao == -1 &&
              request.detalhes?.flgLancado != 1 &&
              data.user?.idUsuario > 0 && (
                <>
                  <Grid className={classeStyle.contentChangeFormPayment}>
                    <Button
                      className={classeStyle.btnChangeFormPayment}
                      style={{ display: 'block' }}
                      onClick={handleFormPayment}
                    >
                      <p className={classeStyle.textBtnCopyPix}>
                        TROCAR FORMA PAGAMENTO
                      </p>
                    </Button>
                  </Grid>
                  <ModalListCenter
                    isOpen={openModalListPaymentFormat}
                    title="FORMAS DE PAGAMENTO"
                    dataList={formPayment}
                    handleFn={async (item) =>
                      handleChangeFormPayment(
                        request.detalhes.idPedido,
                        item.idPagamento,
                        0,
                      )
                    }
                    onClose={() => setOpenModalListPaymentFormat(false)}
                  />
                </>
              )}

            <Grid
              textAlign="left"
              container
              justifyContent="left"
              className={classeStyle.gridTitleId}
            >
              <h5 className={classeStyle.textTitleId}>
                Pedido #{request.detalhes.idPedido}
              </h5>
            </Grid>
            <Grid
              textAlign="left"
              container
              justifyContent="left"
              className={classeStyle.gridContentShop}
            >
              <Grid item xs={12} className={classeStyle.gridDesShop}>
                <p className={classeStyle.textShopLight}>Estabelecimento</p>
                <p className={classeStyle.textShopNormal}>
                  {request.detalhes.dsRestaurante}
                </p>
              </Grid>
              <Grid item xs={12} className={classeStyle.gridDesShop}>
                <p className={classeStyle.textShopLight}>Status</p>
                <Grid container alignItems="center" justifyContent="end">
                  <p
                    className={classeStyle.textShopNormal}
                    style={{ display: 'flex', alignItems: 'center' }}
                  >
                    {request.detalhes.dsSituacao}
                  </p>
                  <Grid
                    style={{
                      width: 15,
                      height: 15,
                      marginLeft: 5,
                      backgroundColor: `${ColorSituationRequest(
                        request.detalhes.idSituacao,
                      )}`,
                      borderRadius: 15,
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} className={classeStyle.gridDesShop}>
                <p className={classeStyle.textShopLight}>Data</p>
                <p className={classeStyle.textShopNormal}>
                  {moment(
                    request.detalhes.dtPedido,
                    'DD/MM/YYYY HH:mm:SS',
                  ).format('lll')}
                </p>
              </Grid>
              <Grid item xs={12} className={classeStyle.gridDesShop}>
                <p className={classeStyle.textShopLight}>Última atualização</p>
                <p className={classeStyle.textShopNormal}>
                  {historyRquest[parseInt(historyRquest?.length, 10) - 2]}
                </p>
              </Grid>
              {request.detalhes.dsMotivo && (
                <Grid item xs={12} className={classeStyle.gridDesShop}>
                  <p className={classeStyle.textShopLight}>
                    Motivo do Cancelamento
                  </p>
                  <p className={classeStyle.textShopNormal}>
                    {request.detalhes.dsMotivo}
                  </p>
                </Grid>
              )}
            </Grid>
            <hr className={classeStyle.hr} />
            <Grid
              textAlign="left"
              container
              justifyContent="left"
              className={classeStyle.gridContentShop}
            >
              <p className={classeStyle.textShopLight}>
                {request.detalhes.dsEndereco}
              </p>
            </Grid>
            <hr className={classeStyle.hr} />
            <Grid className={classeStyle.gridContainerShopItem}>
              {request?.items.length > 0 &&
                request.items.map((itemData: any) => (
                  <Grid
                    container
                    justifyContent="center"
                    item
                    xs={12}
                    key={itemData.idPedidoCardapio}
                  >
                    <Grid
                      textAlign="left"
                      justifyContent="left"
                      className={classeStyle.gridTitleId}
                    >
                      <h5 className={classeStyle.textTitleId}>
                        {itemData.dsCategoria}
                      </h5>
                    </Grid>

                    <Grid className={classeStyle.gridContentShopItem}>
                      <p className={classeStyle.textShopNormal}>
                        {itemData.dsNome}
                      </p>

                      {itemData.dsOpcoes &&
                        itemData.dsOpcoes
                          .split('<br/>')
                          .map((dataItemOption: any) => {
                            return (
                              <p
                                key={dataItemOption}
                                className={
                                  classeStyle.textShopOptionFlavorAddtional
                                }
                              >
                                * {dataItemOption}
                              </p>
                            );
                          })}

                      {itemData.dsSabores &&
                        itemData.dsSabores
                          .split('<br/>')
                          .map((dataItemFlavor: any) => {
                            return (
                              <p
                                key={dataItemFlavor}
                                className={
                                  classeStyle.textShopOptionFlavorAddtional
                                }
                              >
                                * {dataItemFlavor}
                              </p>
                            );
                          })}

                      {itemData.dsAdicionais &&
                        itemData.dsAdicionais
                          .split('<br/>')
                          .map((dataItemAdditional: any) => {
                            return (
                              <p
                                key={dataItemAdditional}
                                className={
                                  classeStyle.textShopOptionFlavorAddtional
                                }
                              >
                                * {dataItemAdditional}
                              </p>
                            );
                          })}

                      <Grid container justifyContent="space-between">
                        <p
                          className={classeStyle.textShopNormal}
                          style={{ fontWeight: 600 }}
                        >
                          R$ {FormatPrice(parseFloat(itemData.vlItem))}
                        </p>
                        <p
                          className={classeStyle.textShopNormal}
                          style={{ fontWeight: 600 }}
                        >
                          {itemData.qtItens}
                        </p>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              <hr className={classeStyle.hr} />
              <Grid container justifyContent="center" item xs={12}>
                <Grid
                  textAlign="left"
                  justifyContent="left"
                  className={classeStyle.gridTitleId}
                >
                  <h5 className={classeStyle.textTitleId}>Valores</h5>
                </Grid>
                <Grid className={classeStyle.gridContentShop}>
                  <Grid item xs={12} className={classeStyle.gridDesShop}>
                    <p className={classeStyle.textShopLight}>Pagamento</p>
                    <p className={classeStyle.textShopNormal}>
                      {request.detalhes.dsPagamento}
                    </p>
                  </Grid>
                  <Grid item xs={12} className={classeStyle.gridDesShop}>
                    <p className={classeStyle.textShopLight}>Produtos</p>
                    <p
                      className={classeStyle.textShopNormal}
                      style={{ fontWeight: 600 }}
                    >
                      R${' '}
                      {FormatPrice(
                        parseFloat(request.detalhes.vlTotal.replace(',', '.')) -
                          parseFloat(
                            request.detalhes.vlEntrega.replace(',', '.'),
                          ),
                      )}
                    </p>
                  </Grid>
                  <Grid item xs={12} className={classeStyle.gridDesShop}>
                    <p className={classeStyle.textShopLight}>Taxa de entrega</p>
                    <p
                      className={classeStyle.textShopNormal}
                      style={{ fontWeight: 600 }}
                    >
                      R$ {request.detalhes.vlEntrega}
                    </p>
                  </Grid>
                  <Grid item xs={12} className={classeStyle.gridDesShop}>
                    <p className={classeStyle.textShopLight}>Total</p>
                    <p
                      className={classeStyle.textShopNormal}
                      style={{ fontWeight: 600 }}
                    >
                      R$ {request.detalhes.vlTotal}
                    </p>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {[1, 2, 3, 4, 5, 7].filter(
            (situcao) => situcao == request?.detalhes.idSituacao,
          ).length == 1 && (
            <div
              className={classeStyle.btnChatRedCicle}
              onClick={() => handleToChat(request?.detalhes)}
            >
              <img
                className={classeStyle.imgIconChatCicle}
                src={imgIconChat}
                alt="IconChat"
              />
            </div>
          )}
        </>
      )}
      <FooterMenuMain children="Request" />

      <ModalConfirmFooter
        isOpen={openErrorModal}
        title={textModal.title}
        message={textModal.description}
        icon={textModal.icon}
        btnNamePrimary="Ok"
        handleFn={async () => setOpenErrorModal(false)}
        onClose={() => setOpenErrorModal(false)}
      />
      <ModalConfirmFooter
        isOpen={openModalNotice}
        title={msgnModalNotice.title}
        message={msgnModalNotice.messagem}
        icon={<IconWallet width={35} height={35} />}
        btnNamePrimary="Confirmar"
        btnCancel="Voltar"
        handleFn={async () =>
          handleChangeFormPayment(
            request.detalhes.idPedido,
            selectedFormPayment,
            1,
          )
        }
        onClose={() => setOpenModalNotice(false)}
      />
    </Container>
  );
};

export default OrderDetail;
